<script setup lang="ts">
import UserAccountInfo from '@/components/UserAccountInfo.vue';
import { useAuthUser } from '@/helpers/globals';

const authUser = useAuthUser();
//console.log(JSON.parse(JSON.stringify(authUser)));

function onModeChange(val: string) {
    //authUser.commit();
    authUser?.set('event_notification_mode', val);
    authUser?.save();
}
</script>

<template>
    <div class="ovr-grid">
        <div class="left">
            <h2 class="ktg-title-02 mb-2rem">{{ $t('notifications') }}</h2>
            <p class="ktg-body-small mt-1rem mb-1rem" v-html="$t('useraccount_notifications_info_text')"></p>
            <div class="useraccountprofilecontainer">
                <h5 class="ktg-title-05">{{ $t('email_benachrichtigungen') }}</h5>
                <div class="radios mt-1rem">
                    <ktg-labelled-choice>
                        <ktg-radio
                            input-id="modeAll"
                            name="mode"
                            value="all"
                            :checked="authUser?.event_notification_mode === 'all'"
                            @change="onModeChange($event.target?.value)"
                        />
                        <ktg-label for="modeAll">{{ $t('event_notification_mode_all') }}</ktg-label>
                    </ktg-labelled-choice>
                    <br />
                    <ktg-labelled-choice>
                        <ktg-radio
                            input-id="modeCreated"
                            name="mode"
                            value="created"
                            :checked="authUser?.event_notification_mode === 'created'"
                            @change="onModeChange($event.target?.value)"
                        />
                        <ktg-label for="modeAll">{{ $t('event_notification_mode_created') }}</ktg-label>
                    </ktg-labelled-choice>
                    <br />
                    <ktg-labelled-choice>
                        <ktg-radio
                            input-id="modeNone"
                            name="mode"
                            value="none"
                            :checked="authUser?.event_notification_mode === 'none'"
                            @change="onModeChange($event.target?.value)"
                        />
                        <ktg-label for="modeAll">{{ $t('event_notification_mode_none') }}</ktg-label>
                    </ktg-labelled-choice>
                </div>
            </div>
        </div>
        <div class="right">
            <UserAccountInfo />
        </div>
    </div>
</template>

<style scoped lang="scss">
.right {
    margin-top: 13px;
    height: fit-content;
    position: sticky;
    top: 8.5rem;
    width: 560px;
    flex-basis: 560px;
}
.left {
    flex-grow: 1 !important;
}
.ovr-grid {
    display: flex;
    gap: 5rem;
    margin-top: 5rem;
    margin-bottom: 5rem;
}

.radios {
    display: flex;
    flex-direction: column;
}

.useraccountprofilecontainer {
    background-color: var(--ktg-color-neutral-01);
    padding: 3rem;

    .element {
        background-color: white;
        padding: 1rem;
    }
}
</style>
